<label class="vox-field-label" translate>company.integrations.edit.form.team_id</label>
<div class="vox-dropdown-input dropdown mb-3" dropdown>
  <div ngbDropdown class="vox-dropdown-input dropdown equipment-type">
    <button class="dropdown__btn" id="type" ngbDropdownToggle type="button">
      {{selectedTeam?.name || '-'}}
      <span class="caret"></span>
    </button>
    <div ngbDropdownMenu aria-labelledby="type">
      <button *ngFor="let team of setupDataTeam" ngbDropdownItem class="dropdown__item" type="button"
        (click)="selectTeam(team)"><span>{{ team.name }}</span></button>
    </div>
  </div>
</div>

<label class="vox-field-label" translate>company.integrations.edit.form.teams_channel_id</label>
<div class="vox-dropdown-input dropdown" dropdown>
  <div ngbDropdown class="vox-dropdown-input dropdown equipment-type">
    <button class="dropdown__btn" id="type2" ngbDropdownToggle type="button">
      {{selectedChannel?.name || '-'}}
      <span class="caret"></span>
    </button>
    <div ngbDropdownMenu aria-labelledby="type2">
      <button *ngFor="let channel of selectedTeam?.channels" ngbDropdownItem class="dropdown__item" type="button"
        (click)="selectChannel(channel)"><span>{{ channel.name }}</span></button>

      <button class="dropdown__item" type="button" translate disabled *ngIf="!selectedTeam || !selectedTeam.channels || selectedTeam.channels.length < 1">
        company.integrations.edit.form.no-channels
      </button>
    </div>
  </div>
</div>